module.exports = "../../app/cells/pages/questions/question_belt_logged_out_cell.rb";